// frontend/src/features/equipment/EquipmentSetupWizard/steps/FiltrationStep.tsx
import { CategoryStep } from './CategoryStep';
import type { PendingEquipment } from '../types';

interface FiltrationStepProps {
  pendingEquipment: PendingEquipment[];
  onEquipmentChange: (equipment: PendingEquipment[]) => void;
  onManageInEquipment?: () => void;
  isCategoryComplete?: boolean;
}

export function FiltrationStep({
  pendingEquipment,
  onEquipmentChange,
  onManageInEquipment,
  isCategoryComplete,
}: FiltrationStepProps) {
  return (
    <CategoryStep
      categoryId="filtration"
      title="What filtration equipment do you have?"
      pendingEquipment={pendingEquipment}
      onEquipmentChange={onEquipmentChange}
      onManageInEquipment={onManageInEquipment}
      isCategoryComplete={isCategoryComplete}
    />
  );
}
